export default class Entity {
  constructor(initialValues = {}) {
    Object.assign(this, initialValues)
  }
}
